import ReactGA from 'react-ga4'

export const analyticsEvent = {
  clickEvent: function (category, action, label = ' ', value = 0) {
    ReactGA.event({
      category: category,
      action: action,
      label: label,
      nonInteraction: true,
      value: value,
    })
    // logs
    console.log('>>>>Event Fired!!')
    console.log({
      category: category,
      action: action,
      label: label,
      value: value,
    })
  },

  endScrollEvent: function (
    targetRef,
    category,
    action,
    label = ' ',
    value = 0,
  ) {
    let newScrollHeight = ~~targetRef.current.getBoundingClientRect().bottom
    if (newScrollHeight === window.innerHeight) {
      console.log('Reached Bottom')
      ReactGA.event({
        category: category,
        action: action,
        label: label,
        value: value,
      })
      //   logs
      console.log('>>>>Event Fired!!')
      console.log({
        category: category,
        action: action,
        label: label,
        value: value,
      })
    }
  },

  scrollByObserver: function (targetRef, category, action, label) {
    // this will need the element ref to track
    console.log('scroll by Observer')
    const opts = {
      root: null,
      rootMargin: '0px',
      threshold: 1.0, // 1 for complete end of scroll
    }
    const callback = (list) => {
      list.forEach((entry) => {
        console.log(entry)
        if (entry.isIntersecting) {
          ReactGA.event({
            category: category,
            action: action,
            label: label,
            value: entry.intersectionRatio,
          })

          // logs
          console.log({
            category: category,
            action: action,
            value: entry.intersectionRatio,
          })
        }
      })
    }
    const observerScroll = new IntersectionObserver(callback, opts)

    observerScroll.observe(targetRef.current)
  },

  log: function (category, action, label = ' ', value = 0) {
    console.log({
      category: category,
      action: action,
      label: label,
      value: value,
    })
  },
}

export const eventName = {
  // event name
  // key value pairs of all event name
  Intro_mute: 'Intro Mute',
  Intro_unmute: 'Intro Unmute',
  Intro_right_swipe: 'Intro Right Swipe',
  Intro_left_swipe: 'Intro Left Swipe',
  Intro_right_caraousel_click: 'Intro Right caraousel click',
  Intro_left_caraousel_click: 'Intro Left caraousel click',
  Intro_view_trip_details_click: 'Intro View trip details click',
  Intro_share_opened: 'Intro Share opened',
  Intro_share_success: 'Intro Share success',
  Media_tab_selected: 'Media Tab selected',
  Media_intro_selected: 'Media Intro selected',
  Media_next_day_selected: 'Media Next day selected',
  Media_previous_day_selected: 'Media Previous day selected',
  Media_right_swipe: 'Media Right swipe',
  Media_left_swipe: 'Media Left swipe',
  Media_right_caraousel_click: 'Media Right caraousel click',
  Media_left_caraousel_click: 'Media Left caraousel click',
  Media_view_item_details: 'Media View item details',
  Media_share_opened: 'Media Share opened',
  Media_share_success: 'Media Share success',
  Media_chat_opened: 'Media Chat opened',
  Media_scrolled_till_end_of_page: 'Media Scrolled till end of page',
  Overview_tab_selected: 'Overview Tab selected',
  Overview_share_opened: 'Overview Share opened',
  Overview_share_success: 'Overview Share success',
  Overview_chat_opened: 'Overview Chat opened',
  Overview_scrolled_till_end_of_page: 'Overview Scrolled till end of page',
  Overview_note_expanded: 'Overview Note expanded/clicked',
  Stays_tab_selected: 'Stays Tab selected',
  Stays_share_opened: 'Stays Share opened',
  Stays_share_success: 'Stays Share success',
  Stays_chat_opened: 'Stays Chat opened',
  Stays_scrolled_till_end_of_page: 'Stays Scrolled till end of page',
  Stays_note_expanded: 'Stays Note expanded/clicked',
  Stays_view_item_details: 'Stays View item details',
  Stops_tab_selected: 'Stops Tab selected',
  Stops_share_opened: 'Stops Share opened',
  Stops_share_success: 'Stops Share success',
  Stops_chat_opened: 'Stops Chat opened',
  Stops_scrolled_till_end_of_page: 'Stops Scrolled till end of page',
  Stops_note_expanded: 'Stops Note expanded/clicked',
  Stops_view_item_details: 'Stops View item details',
  Item_detail_back_button_pressed: 'Detail Page Back button pressed',
  Item_detail_share_opened: 'Detail Page Share opened',
  Item_detail_share_success: 'Detail Page Share success',
  Item_detail_chat_opened: 'Detail Page Chat opened',
  Item_detail_scrolled_till_end_of_page:
    'Detail Page Scrolled till end of page',
  Item_detail_view_all_selected_in_media:
    'Detail Page View all selected in media',
}
